import React from 'react';
import errorImage from '../../Components/App/Images/Error-image.png';

const ErrorPage = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <h1>Oops! Something went wrong.</h1>
      <p>We're sorry, but the page you're looking for is either down or has an invalid URL</p>
      <img src={errorImage} alt="Error" style={{ width: '180px', height: '100px' }} />
    </div>
  );
};

export default ErrorPage;